/* Nurturi — pdp.js   (loaded only on product pages, deferred)
   Gallery + swipe, variant selection, add-on line item, animated accordions,
   sticky add-to-cart. Depends on window.Nurturi (global.js) for cart + money. */
(function () {
  'use strict';

  function money(cents) {
    return (window.Nurturi && window.Nurturi.formatMoney) ? window.Nurturi.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }

  function initSection(root) {
    if (!root || root._ntInit) return;
    root._ntInit = true;

    /* ---------------- Gallery ---------------- */
    root.querySelectorAll('[data-gallery]').forEach(function (g) {
      var track = g.querySelector('[data-gallery-track]');
      if (!track) return;
      var slides = track.children;
      var count = slides.length;
      var dots = g.querySelectorAll('[data-gallery-go]');
      var index = 0;

      function render() {
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      }
      function go(i) { index = (i % count + count) % count; render(); }
      g._go = go;

      var prev = g.querySelector('[data-gallery-prev]');
      var next = g.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-gallery-go'), 10)); }); });

      // swipe (horizontal lock, 40px threshold)
      var x0 = null, y0 = null, locked = null;
      track.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; locked = null; }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (x0 === null) return;
        var t = e.touches[0];
        if (locked === null) locked = Math.abs(t.clientX - x0) > Math.abs(t.clientY - y0) ? 'x' : 'y';
        if (locked === 'x') e.preventDefault();
      }, { passive: false });
      track.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (locked === 'x' && Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); }
        x0 = y0 = locked = null;
      }, { passive: true });

      render();
    });

    function galleriesGoToMedia(mediaId) {
      if (!mediaId) return;
      root.querySelectorAll('[data-gallery]').forEach(function (g) {
        var slides = g.querySelectorAll('.gallery__slide');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') == mediaId) { if (g._go) g._go(i); break; }
        }
      });
    }

    /* ---------------- Variants ---------------- */
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-product-variants]').textContent); } catch (e) {}
    var financeCount = parseInt(root.getAttribute('data-finance-count'), 10) || 4;

    var current = variants.filter(function (v) { return String(v.id) === root.getAttribute('data-current-variant'); })[0] || variants[0];
    var selected = current ? current.options.slice() : [];

    function show(el, on) { if (el) el.toggleAttribute('hidden', !on); }

    function applyVariant(v) {
      current = v;
      var has = v && v.compare_at_price > v.price;
      var pct = has ? Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) : 0;

      root.querySelectorAll('[data-price-now]').forEach(function (e) { e.textContent = v ? money(v.price) : '—'; });
      root.querySelectorAll('[data-cta-now]').forEach(function (e) { e.textContent = v ? money(v.price) : ''; });
      root.querySelectorAll('[data-price-was]').forEach(function (e) { show(e, has); if (has) e.textContent = money(v.compare_at_price); });
      root.querySelectorAll('[data-cta-was]').forEach(function (e) { show(e, has); if (has) e.textContent = money(v.compare_at_price); });
      root.querySelectorAll('[data-discount]').forEach(function (e) { show(e, has); if (has) e.textContent = pct + '% OFF'; });
      root.querySelectorAll('[data-finance]').forEach(function (e) { if (v) e.textContent = money(Math.round(v.price / financeCount)); });
      root.querySelectorAll('[data-sticky-variant]').forEach(function (e) { if (v) e.textContent = v.title; });

      var available = v && v.available;
      root.querySelectorAll('[data-atc]').forEach(function (btn) {
        btn.disabled = !available;
        var label = btn.querySelector('[data-atc-text]');
        if (label) label.textContent = !v ? (window.Nurturi ? 'Unavailable' : 'Unavailable') : (available ? 'Add to Cart' : 'Sold out');
      });

      if (v) {
        galleriesGoToMedia(v.media_id);
        if (history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u);
        }
        root.setAttribute('data-current-variant', v.id);
      }
    }

    function resolveVariant() {
      var match = variants.filter(function (v) {
        return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
      })[0];
      applyVariant(match || null);
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-option-value]');
      if (!opt) return;
      var pos = parseInt(opt.getAttribute('data-option-value'), 10);
      var val = opt.getAttribute('data-value');
      selected[pos - 1] = val;
      // sync every instance of this option (desktop + mobile)
      root.querySelectorAll('[data-option-value="' + pos + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-value') === val ? 'true' : 'false');
      });
      root.querySelectorAll('[data-option-selected="' + pos + '"]').forEach(function (s) { s.textContent = val; });
      resolveVariant();
    });

    /* ---------------- Add-on ---------------- */
    var addonOn = false;
    function addonVariantId() {
      var el = root.querySelector('[data-addon-variant]');
      return el ? el.getAttribute('data-addon-variant') : null;
    }
    root.querySelectorAll('[data-addon-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addonOn = !addonOn;
        root.querySelectorAll('[data-addon-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', addonOn ? 'true' : 'false'); });
      });
    });

    /* ---------------- Add to cart ---------------- */
    root.querySelectorAll('[data-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!current || !current.available || !window.Nurturi) return;
        var items = [{ id: current.id, quantity: 1 }];
        var addonId = addonVariantId();
        if (addonOn && addonId) items.push({ id: parseInt(addonId, 10), quantity: 1 });
        var label = btn.querySelector('[data-atc-text]');
        var original = label ? label.textContent : '';
        if (label) label.textContent = 'Adding…';
        btn.disabled = true;
        window.Nurturi.addToCart(items).then(function () {
          if (label) label.textContent = 'Added ✓';
          setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 1200);
        }).catch(function () { if (label) label.textContent = original; btn.disabled = false; });
      });
    });

    /* ---------------- Accordions (one open / group, animated) ---------------- */
    var DUR = 320, EASE = DUR + 'ms cubic-bezier(.4,0,.2,1)';
    // Batch the getComputedStyle reads (pass 1) apart from the style writes (pass 2) so the
    // 8 accordions (4 × both layouts) don't force a layout flush on every iteration.
    var accItems = [];
    root.querySelectorAll('details[data-accordion]').forEach(function (d) {
      var summary = d.querySelector('summary');
      var body = summary ? summary.nextElementSibling : null;
      if (!body) return;
      var cs = getComputedStyle(body);
      accItems.push({ d: d, summary: summary, body: body, padTop: cs.paddingTop, padBottom: cs.paddingBottom });
    });
    accItems.forEach(function (it) {
      var d = it.d, summary = it.summary, body = it.body, padTop = it.padTop, padBottom = it.padBottom;
      body.style.overflow = 'hidden';
      body.style.willChange = 'height, padding';
      if (!d.open) { body.style.height = '0px'; body.style.paddingTop = '0px'; body.style.paddingBottom = '0px'; }

      d._close = function () {
        if (!d.open || d._busy) return;
        d._busy = true;
        body.style.transition = 'none';
        body.style.height = body.scrollHeight + 'px';
        body.style.paddingTop = padTop; body.style.paddingBottom = padBottom;
        requestAnimationFrame(function () {
          body.style.transition = 'height ' + EASE + ', padding ' + EASE;
          body.style.height = '0px'; body.style.paddingTop = '0px'; body.style.paddingBottom = '0px';
        });
        setTimeout(function () { d.open = false; d._busy = false; }, DUR + 20);
      };
      d._open = function () {
        if (d.open || d._busy) return;
        d._busy = true; d.open = true;
        body.style.transition = 'none';
        body.style.height = 'auto'; body.style.paddingTop = padTop; body.style.paddingBottom = padBottom;
        var h = body.scrollHeight;
        body.style.height = '0px'; body.style.paddingTop = '0px'; body.style.paddingBottom = '0px';
        requestAnimationFrame(function () {
          body.style.transition = 'height ' + EASE + ', padding ' + EASE;
          body.style.height = h + 'px'; body.style.paddingTop = padTop; body.style.paddingBottom = padBottom;
        });
        setTimeout(function () { body.style.height = 'auto'; d._busy = false; }, DUR + 20);
      };

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d._busy) return;
        if (d.open) { d._close(); }
        else {
          d.parentElement.querySelectorAll(':scope > details[data-accordion]').forEach(function (o) { if (o !== d && o.open) o._close(); });
          d._open();
        }
      });
    });

    /* -------- Buy-box star rating → open + scroll to the reviews dropdown -------- */
    function goToReviews(fromEl) {
      var scope = fromEl.closest('.pdp-desktop, .pdp-mobile') || root;
      var acc = scope.querySelector('[data-reviews-acc]');
      if (!acc) return;
      if (!acc.open && acc._open) {
        acc.parentElement.querySelectorAll(':scope > details[data-accordion]').forEach(function (o) { if (o !== acc && o.open && o._close) o._close(); });
        acc._open();
      }
      var header = document.querySelector('.section-header');
      var off = (header ? header.getBoundingClientRect().height : 0) + 14;
      window.scrollTo({ top: acc.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
    }
    root.querySelectorAll('[data-reviews-link]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); goToReviews(el); });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goToReviews(el); } });
    });

    /* ---------------- Sticky ATC (mobile) ---------------- */
    /* Shown only through the middle of the PDP: after the buy box scrolls above the
       top, and hidden again once the static Add-to-Cart at the bottom is reached
       (stays hidden through the footer; reappears if scrolled back up above it). */
    var anchor = root.querySelector('[data-sticky-anchor]');
    var bar = root.querySelector('[data-sticky-bar]');
    var finalCta = document.querySelector('[data-btf-atc]'); // static CTA at the bottom of the PDP
    if (anchor && bar && 'IntersectionObserver' in window) {
      var pastBuyBox = false, atFinalCta = false;
      var applyStickyBar = function () {
        var show = pastBuyBox && !atFinalCta;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.inert = !show;
      };
      new IntersectionObserver(function (entries) {
        pastBuyBox = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        applyStickyBar();
      }, { threshold: 0 }).observe(anchor);
      if (finalCta) {
        new IntersectionObserver(function (entries) {
          // true once the static CTA reaches the bar's zone, and stays true below it
          atFinalCta = entries[0].isIntersecting || entries[0].boundingClientRect.top < 0;
          applyStickyBar();
        }, { threshold: 0, rootMargin: '0px 0px -64px 0px' }).observe(finalCta);
      }
    }

    /* -------- Okendo rating hydration (fallback when the SSR metafield summary is empty) -------- */
    (function () {
      var source = root.querySelector('[data-pdp-rating-source]');
      if (!source) return; // SSR already had live data, or Okendo is off
      var obs = null, poll = null, done = false;

      function finish() { done = true; if (obs) obs.disconnect(); if (poll) clearInterval(poll); }

      function hydrate() {
        if (done) return;
        var text = (source.textContent || '').replace(/\s+/g, ' ').trim();
        var aria = '';
        source.querySelectorAll('[aria-label]').forEach(function (el) { aria += ' ' + (el.getAttribute('aria-label') || ''); });
        var hay = (aria + ' ' + text).trim();
        if (!hay) return;

        var m = hay.match(/([0-5](?:\.\d+)?)\s*(?:out of|\/)\s*5/i);
        var avg = m ? parseFloat(m[1]) : NaN;
        var c = hay.match(/(\d[\d,]*)\s*(?:reviews?|ratings?)/i) || hay.match(/\((\d[\d,]*)\)/);
        var count = c ? parseInt(c[1].replace(/,/g, ''), 10) : NaN;

        if (isNaN(avg) || avg <= 0 || avg > 5) return;
        if (isNaN(count) || count <= 0) return;

        finish();
        var avgFmt = (Math.round(avg * 10) / 10).toFixed(1);
        root.querySelectorAll('[data-rating-val]').forEach(function (el) { el.textContent = avgFmt; });
        root.querySelectorAll('[data-rating-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
      }

      try {
        if ('MutationObserver' in window) {
          obs = new MutationObserver(hydrate);
          obs.observe(source, { childList: true, subtree: true, characterData: true });
        }
        poll = setInterval(hydrate, 600);
        setTimeout(finish, 12000);
        hydrate();
      } catch (e) {}
    })();

    /* -------- Reviews "Read more" clamp (Okendo's native truncation is unreliable in the dual-layout accordion) -------- */
    (function () {
      function clamp() {
        root.querySelectorAll('.oke-reviewContent-body').forEach(function (body) {
          if (body.dataset.ntClamp) return;
          if (!body.offsetParent) return;                       // hidden (other layout) → handle when visible
          body.dataset.ntClamp = '1';
          if (body.scrollHeight - body.clientHeight < 4) return; // fits → no toggle needed
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nt-readmore';
          btn.textContent = 'Read more';
          body.insertAdjacentElement('afterend', btn);
          btn.addEventListener('click', function () {
            var open = body.classList.toggle('nt-open');
            btn.textContent = open ? 'Read less' : 'Read more';
          });
        });
      }
      try {
        if ('MutationObserver' in window) {
          var ct;                                             // debounce: Okendo fires many mutations while rendering — coalesce into one measure pass
          var ro = new MutationObserver(function () { clearTimeout(ct); ct = setTimeout(clamp, 120); });
          root.querySelectorAll('[data-oke-widget]').forEach(function (w) { ro.observe(w, { childList: true, subtree: true }); });
        }
        var rt;
        window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(clamp, 200); });
        clamp();
      } catch (e) {}
    })();

    /* -------- AI summary "Read more" (5-line clamp; our own server-rendered markup, so re-check after fonts/resize) -------- */
    (function () {
      function setup() {
        root.querySelectorAll('.pdp-okendo-summary__ai-body').forEach(function (body) {
          if (body.dataset.ntClamp) return;
          if (!body.offsetParent) return;                        // hidden layout → handle when visible
          if (body.scrollHeight - body.clientHeight < 4) return; // fits → leave unmarked so a later pass can re-check
          body.dataset.ntClamp = '1';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nt-readmore';
          btn.textContent = 'Read more';
          body.insertAdjacentElement('afterend', btn);
          btn.addEventListener('click', function () {
            body.classList.add('nt-open');   // expand fully, then remove the link (no "Read less")
            btn.remove();
          });
        });
      }
      try {
        var rt;
        window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(setup, 200); });
        setup();
        setTimeout(setup, 500);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(setup);
      } catch (e) {}
    })();

    // set initial variant state
    if (current) applyVariant(current);
  }

  function boot() { document.querySelectorAll('[data-product-section]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-product-section]');
    if (sec) { sec._ntInit = false; initSection(sec); }
  });
})();

/* PDP below-the-fold (pdp-btf): M16 close CTA proxies the buy-box Add-to-Cart and mirrors its live price/label. */
(function () {
  var wrap = document.querySelector('[data-btf]');
  if (!wrap) return;
  var proxy = wrap.querySelector('[data-btf-atc]');
  var real = document.querySelector('[data-product-section] [data-atc]');
  if (!proxy || !real) return;
  proxy.addEventListener('click', function () {
    real.click();
    (window.dataLayer = window.dataLayer || []).push({ event: 'atc_click', placement: 'close' });
  });
  [
    [document.querySelector('[data-product-section] [data-price-now]'), wrap.querySelector('[data-btf-now]')],
    [document.querySelector('[data-product-section] [data-price-was]'), wrap.querySelector('[data-btf-was]')],
    [real.querySelector('[data-atc-text]'), wrap.querySelector('[data-btf-atc-text]')]
  ].forEach(function (p) {
    var src = p[0], dst = p[1];
    if (!src || !dst) return;
    var sync = function () {
      dst.textContent = src.textContent;
      if (src.hasAttribute && src.hasAttribute('hidden')) { dst.setAttribute('hidden', ''); } else { dst.removeAttribute('hidden'); }
    };
    sync();
    if ('MutationObserver' in window) { new MutationObserver(sync).observe(src, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] }); }
  });
})();

/* ===== Mobile PDP sticky chrome =============================================
   Announcement + nav are fixed top-chrome that hide/reveal on scroll direction.
   Announcement hides once the carousel top reaches it; nav hides once the sticky
   Add-to-Cart shows. On scroll-up the announcement reveals first, the nav follows
   (fade + slide, staggered in CSS). Passive + rAF-throttled; mobile PDP only. */
(function () {
  var mq = window.matchMedia('(max-width:768px)');
  var html = document.documentElement;
  var ann = document.querySelector('.section-announcement');
  var nav = document.querySelector('.section-header');
  var gallery = document.querySelector('.pdp-only-mobile [data-gallery]');
  var anchor = document.querySelector('[data-sticky-anchor]'); // mobile buy card (drives the sticky ATC)
  if (!nav || !gallery) return; // only wire up on a PDP with the expected structure

  var active = false, ticking = false, lastY = 0, dir = 'up';

  function measure() {
    var annH = ann ? ann.offsetHeight : 0;
    html.style.setProperty('--nt-ann-h', annH + 'px');
    html.style.setProperty('--nt-chrome-h', (annH + nav.offsetHeight) + 'px');
  }

  function update() {
    ticking = false;
    var y = window.pageYOffset || 0;
    if (y > lastY + 3) dir = 'down'; else if (y < lastY - 3) dir = 'up';
    lastY = y;
    var annH = ann ? ann.offsetHeight : 0;
    var annReady = gallery.getBoundingClientRect().top <= annH + 1;  // carousel top reached the bar
    var navReady = !!(anchor && anchor.getBoundingClientRect().bottom <= 0);  // buy card scrolled past → sticky ATC shows
    html.classList.toggle('nt-ann-hidden', annReady && dir === 'down');
    html.classList.toggle('nt-nav-hidden', navReady && dir === 'down');
  }

  function onScroll() { if (active && !ticking) { ticking = true; requestAnimationFrame(update); } }

  function activate() {
    if (active) return;
    active = true;
    measure();
    html.classList.add('nt-pdp-sticky');
    lastY = window.pageYOffset || 0;
    update();
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (active) html.classList.add('nt-chrome-anim'); }); });
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  function deactivate() {
    if (!active) return;
    active = false;
    window.removeEventListener('scroll', onScroll);
    html.classList.remove('nt-pdp-sticky', 'nt-chrome-anim', 'nt-ann-hidden', 'nt-nav-hidden');
  }
  function sync() { if (mq.matches) activate(); else deactivate(); }

  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (active) measure(); }, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (active) measure(); });
})();
